import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  dialogTitle: {
    paddingBottom: 0,
  },
  titleLabel: {
    fontWeight: 700,
    fontSize: '1.1rem',
    lineHeight: 1.4,
  },
  partnerName: {
    fontSize: '0.875rem',
    color: 'rgba(0,0,0,0.75)',
    marginTop: 2,
  },
  cnpj: {
    fontSize: '0.8rem',
    color: 'rgba(0,0,0,0.5)',
    fontFamily: 'monospace',
    marginTop: 2,
  },
  tabs: {
    minHeight: 44,
  },

  tab: {
    minHeight: 44,
    textTransform: 'none',
    fontSize: '0.875rem',
    fontWeight: 500,
    minWidth: 0,
    padding: '6px 16px',
  },

  tabIcon: {
    fontSize: 16,
    marginBottom: '0 !important',
  },

  summaryRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '10px 0 4px',
    flexWrap: 'wrap',
  },
  summaryText: {
    fontSize: '0.8rem',
    color: 'rgba(0,0,0,0.55)',
  },
  dialogContent: {
    paddingTop: 8,
    paddingBottom: 16,
  },
  cardList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  docCard: {
    border: '1px solid rgba(0,0,0,0.12)',
    borderRadius: 6,
    overflow: 'hidden',
    backgroundColor: '#fff',
  },
  docCardRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 12px',
    gap: 12,
  },
  docIconBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    borderRadius: 6,
    flexShrink: 0,
  },
  docInfo: {
    flex: 1,
    minWidth: 0,
  },
  docName: {
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: 1.3,
  },
  docDate: {
    fontSize: '0.75rem',
    color: 'rgba(0,0,0,0.5)',
    marginTop: 1,
  },
  docActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    flexShrink: 0,
  },
  downloadBtn: {
    color: 'rgba(0,0,0,0.4)',
    padding: 4,
    '&:hover': {
      color: theme.palette.primary?.main || '#1565C0',
    },
  },
  statusLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    fontSize: '0.8rem',
    fontWeight: 500,
    fontFamily: theme.typography.fontFamily,
    whiteSpace: 'nowrap',
  },
  chevronBtn: {
    padding: 4,
    color: 'rgba(0,0,0,0.4)',
  },
  historyBox: {
    margin: '0 12px 10px',
    padding: '10px 12px',
    borderTop: '1px solid rgba(0,0,0,0.07)',
  },
  historyTitle: {
    fontSize: '0.7rem',
    fontWeight: 700,
    fontFamily: theme.typography.fontFamily,
    color: 'rgba(0,0,0,0.38)',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    marginBottom: 8,
  },
  historyEvent: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    marginBottom: 8,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  historyDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'rgba(0,0,0,0.2)',
    flexShrink: 0,
    marginTop: 4,
  },
  historyEventContent: {
    flex: 1,
    minWidth: 0,
  },
  historyEventRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 8,
  },
  historyEventDate: {
    fontSize: '0.75rem',
    color: 'rgba(0,0,0,0.45)',
    fontFamily: theme.typography.fontFamily,
    marginBottom: 1,
  },
  historyEventAction: {
    fontSize: '0.8rem',
    fontWeight: 500,
    fontFamily: theme.typography.fontFamily,
    color: 'rgba(0,0,0,0.75)',
  },
  historyEventActor: {
    fontSize: '0.75rem',
    color: 'rgba(0,0,0,0.45)',
    fontFamily: theme.typography.fontFamily,
    whiteSpace: 'nowrap',
    marginTop: 'auto',
    paddingBottom: 1,
  },
  historyReason: {
    fontSize: '0.75rem',
    color: 'rgba(0,0,0,0.55)',
    fontFamily: theme.typography.fontFamily,
    marginTop: 3,
    fontStyle: 'italic',
  },
  emptyState: {
    textAlign: 'center',
    padding: '32px 0',
    color: 'rgba(0,0,0,0.45)',
    fontSize: '0.875rem',
  },
  loadingWrapper: {
    display: 'flex',
    justifyContent: 'center',
    padding: '32px 0',
  },
  closeBtn: {
    position: 'absolute',
    right: 12,
    top: 12,
    color: 'rgba(0,0,0,0.4)',
    padding: 4,
  },

  tabWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },

  tabBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    verticalAlign: 'middle',
    flexShrink: 0,
    minWidth: 18,
    height: 18,
    borderRadius: 9,
    backgroundColor: '#E65100',
    color: '#fff',
    fontSize: '0.65rem',
    fontWeight: 700,
    lineHeight: 1,
  },

  missingSection: {
    marginTop: 16,
  },
  missingSectionTitle: {
    fontSize: '0.75rem',
    fontWeight: 600,
    fontFamily: theme.typography.fontFamily,
    color: 'rgba(0,0,0,0.4)',
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    marginBottom: 6,
  },
  missingDocCard: {
    border: '1px solid rgba(0,0,0,0.12)',
    borderRadius: 6,
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 12px',
    gap: 12,
  },
  missingDocLabel: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: 'rgba(0,0,0,0.75)',
    lineHeight: 1.3,
  },
  missingDocSubLabel: {
    fontSize: '0.75rem',
    color: 'rgba(0,0,0,0.5)',
    marginTop: 1,
  },
}));
